import React from 'react'
import PropTypes from 'prop-types'
import { Link } from 'react-router-dom'
import classNames from 'classnames'

import { parseLocation, makeLink } from '../../../common/utils/urlHelper'
import InnerHtml from '../../components/innerHtml'
import SearchBarForm from '../../components/searchBar/searchBarForm'
import SearchBarAutoSuggest from '../../components/searchBar/searchBarAutoSuggest'
import Autosuggest from '../../components/autosuggest/'

class SearchHeader extends React.Component {
  static propTypes = {
    location: PropTypes.object,
    totalHits: PropTypes.number,
    resultsTerm: PropTypes.string,
    didYouMeanByTerms: PropTypes.array,
    authorSuggestion: PropTypes.object,
    searchHeadings: PropTypes.object,
    currentSite: PropTypes.string,
    hideSearchBar: PropTypes.bool
  }

  static defaultProps = {
    totalHits: 0,
    didYouMeanByTerms: [],
    authorSuggestion: null
  }

  renderResultsInfo () {
    const { location, searchHeadings } = this.props
    const parsedLocation = parseLocation(location)
    const shouldShowSubheading = (!parsedLocation.page || (parsedLocation.page && parsedLocation.page === '1')) && searchHeadings.sub_heading

    return (
      <div>
        <h1 className='fds-c-text-heading -color-light -size-xs h-remove-margin -weight-normal'>
          <InnerHtml>
            {searchHeadings.heading}
          </InnerHtml>
        </h1>
        {shouldShowSubheading &&
          <h2 className='fds-c-text-heading -color-light -size-xs -weight-normal fds-u-hide-small-and-below'>
            <InnerHtml>
              {searchHeadings.sub_heading}
            </InnerHtml>
          </h2>
        }
      </div>
    )
  }

  renderNoResultsFound () {
    return (
      <h1 className='fds-c-text-heading -color-light -size-xs h-remove-margin -weight-normal fds-u-hide-small-and-below'>
        No results found
      </h1>
    )
  }

  renderDidYouMeanBy () {
    const { didYouMeanByTerms, location } = this.props
    const parsedLocation = parseLocation(location)
    return (
      <p>
        {'Did you mean: '}
        {didYouMeanByTerms.map((term, index) => {
          const nextQuery = Object.assign({}, parsedLocation, {
            term
          })
          return (
            <span key={index}><Link to={makeLink(nextQuery)}>{term}</Link>{index < didYouMeanByTerms.length - 1 ? ', ' : null}</span>
          )
        })}?
      </p>
    )
  }

  renderAuthorSuggestions () {
    const {authorSuggestion} = this.props

    return (
      <p className='author-search-result'>
        {'We found an author by that name: '}
        {authorSuggestion
          ? <a href={authorSuggestion.url}>
            {authorSuggestion.username}
          </a> : null}
      </p>
    )
  }

  renderSuggestions () {
    const { didYouMeanByTerms, authorSuggestion } = this.props
    return (
      <div className='search-header__extras'>
        {authorSuggestion ? this.renderAuthorSuggestions() : null}
        {didYouMeanByTerms.length ? this.renderDidYouMeanBy() : null}
      </div>
    )
  }

  renderSearchBar () {
    const { location, currentSite } = this.props
    const parsedLocation = parseLocation(location)

    return (
      <div className='fds-u-p2'>
        <SearchBarForm className='huge-search--search-home' location={location}>
          <SearchBarAutoSuggest
            name='term'
            value={parsedLocation.term}
            placeholder='Search within these results'
            currentSite={currentSite}
            location={location}
            autosuggest={Autosuggest} />
        </SearchBarForm>
      </div>
    )
  }

  render () {
    const {
      resultsTerm,
      totalHits,
      didYouMeanByTerms,
      authorSuggestion,
      searchHeadings,
      currentSite,
      hideSearchBar
    } = this.props

    const shouldShowSearchHeadings = searchHeadings && searchHeadings.heading && totalHits > 0
    const shouldShowNoResults = resultsTerm && !totalHits

    const pageSectionClassNames = classNames('page-section', '-size-xcompact', `-theme-${currentSite || 'themeforest'}`)
    const resultsCountClassNames = classNames('search-header__results-count', {
      'fds-u-pt2': hideSearchBar
    })
    return (
      <div id='search-header'>
        <div className={pageSectionClassNames}>
          <div className='page-section__content'>
            <div className='page-section__background' />
            <div className='search-header__form-wrapper'>
              { !hideSearchBar && this.renderSearchBar()}
              <div className={resultsCountClassNames}>
                {shouldShowSearchHeadings && this.renderResultsInfo()}
                {shouldShowNoResults && this.renderNoResultsFound()}
                {didYouMeanByTerms.length || authorSuggestion ? this.renderSuggestions() : null}
              </div>
            </div>
          </div>
        </div>
      </div>
    )
  }
}

export default SearchHeader



// WEBPACK FOOTER //
// ./client/pages/search/searchHeader.js